/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SwatchSelector_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedSwatchSelector_item$ref: FragmentReference;
export type PdpSharedSwatchSelector_item = {|
  +$fragmentRefs: SwatchSelector_item$ref,
  +$refType: PdpSharedSwatchSelector_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedSwatchSelector_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '69a801841260f2dbb242fee76d66634a';
module.exports = node;
